import StaticPage from '@wetransfer/transfer/component/panel/content';
import Analytics from '@wetransfer/transfer/modules/analytics';
import Zopim, { loadSnippet } from '@wetransfer/transfer/modules/zopim';
import Store from '@wetransfer/transfer/store';

// This will contain the StatusPage JS client
let client = false;
// To figure out what's the first action a user makes, provides more analytical value
let firstAction = true;

// Initialize the client
function setupClient() {
  if (typeof window['StatusPage'] !== 'object') {
    return;
  }
  // eslint-disable-next-line no-undef
  client = new StatusPage.page({
    page: 'sc26zwwp3c0r',
  });
}

function track(tracked_action, label) {
  let action = tracked_action;

  if (firstAction) {
    action = `${action} (First Action)`;
    firstAction = false;
  }

  Analytics.trackGoogleEvent({
    category: 'Help Page',
    action,
    label,
  });
}

// Get the status and update the needed DOM elements
function getStatus(node) {
  if (!client) {
    return;
  }

  const parent = node.querySelector('.status');
  const link = parent.querySelector('a.indicator');

  // Load the status from the StatusPage client
  client.summary({
    success(data) {
      parent.classList.add(data.status.indicator);
      link.setAttribute('href', data.page.url);
      link.innerText = data.status.description;
    },
  });
}

// Show Zopim chat
function showChat() {
  const { user, session, route } = Store.getState();

  const callback = () => {
    Zopim.setVisitorSettings({
      name: user.given_name,
      email: user.email,
      language: session.language,
    });
    Zopim.setVisitorPath(route.path, route.title);
    Zopim.tag('inline_chat_experiment');
    Zopim.showInlineChat();
  };

  if (Zopim.isReady()) {
    callback();
  } else {
    loadSnippet().then(callback);
  }
}

const pageCallback = (instance) => {
  // We want to be updated with store updates
  instance.subscribeToStore = true;

  // If we don't have a client yet, try to load the StatusPage library first
  if (!client) {
    const script = document.createElement('script');
    script.src = '//cdn.statuspage.io/se-v2.js';

    script.onload = () => {
      setupClient();
      getStatus(instance.node);
    };
    document.querySelector('head').appendChild(script);
  } else {
    getStatus(instance.node);
  }

  // Click on question
  const analyticsLinks = Array.from(
    instance.node.querySelectorAll('[data-analytics-label]')
  );

  const linkClickHandler = (e) => {
    track('Link Click', e.currentTarget.getAttribute('data-analytics-label'));
  };
  analyticsLinks.forEach((link) => {
    link.addEventListener('click', linkClickHandler);
  });

  // Form submission
  const formElement = instance.node.querySelector('.help-section form');
  const searchElement = instance.node.querySelector('input[name="query"]');

  const searchHandler = (event) => {
    event.stopImmediatePropagation();
    track('Search', searchElement.value);

    Analytics.trackSnowplowEvent({
      category: 'help_page',
      action: 'click_search',
    });
  };
  formElement.addEventListener('submit', searchHandler);

  const ticketButton = instance.node.querySelector('.more-answers__button');

  const ticketButtonHandler = (event) => {
    event.stopImmediatePropagation();
    Analytics.trackSnowplowEvent({
      category: 'help_page',
      action: 'click_more_answers',
    });
  };
  ticketButton.addEventListener('click', ticketButtonHandler);

  const liveChatButton = instance.node.querySelector('.live-chat__button');

  if (liveChatButton) {
    liveChatButton.removeAttribute('href');
    liveChatButton.removeAttribute('rel');
    liveChatButton.addEventListener('click', showChat);
  }

  // When we navigate away from the page, cleanup listeners
  instance.onCleanup = () => {
    analyticsLinks.forEach((link) => {
      link.removeEventListener('click', linkClickHandler);
    });
    formElement.removeEventListener('submit', searchHandler);
    ticketButton.removeEventListener('click', ticketButtonHandler);
    firstAction = true;
  };
};

StaticPage.configure('/help', pageCallback);

export default pageCallback;
